import React from "react";
import TestContent from "./components/TestContent";
function TestPage() {
  return (
    <div>
      <TestContent />
    </div>
  );
}
export default TestPage;
